import React from 'react'

// MUI Imports
import {
  Typography,
  Tooltip
} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

const EmailStatusItem = (props) => {
  const {
    title,
    text,
    highlightedTextPart,
    Icon,
    infoText
  } = props

  return (
    <div className='flex items-center gap-2'>
      <div className='flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 border border-blue-100'>
        <Icon sx={{
          width: 18,
          height: 18,
          color: 'primary.main'
        }}/>
      </div>
      <div className='flex flex-col -space-y-px'>
        <Typography
          noWrap
          variant='body2'
          color='text.primary'
          className='text-sm font-bold leading-none'
          sx={{ letterSpacing: 'normal' }}
        >
          {text}
          {highlightedTextPart && (
            <span className='text-xs font-semibold ml-1 bg-green-50 text-green-600 rounded leading-none'>{highlightedTextPart}</span>
          )}
        </Typography>

        <Typography
          noWrap
          variant='caption'
          color='text.secondary'
          className='text-xs font-medium leading-none'
          sx={{ letterSpacing: 'normal' }}
        >
          {title}
          {infoText && (
            <Tooltip
              title={infoText}
              arrow
            >
              <InfoIcon
                sx={{ width: 12, height: 12, marginLeft: 0.5, opacity: 0.7 }}
                onClick={(e) => { e.preventDefault() }}
              />
            </Tooltip>
          )}
        </Typography>
      </div>
    </div>
  )
}

export default EmailStatusItem
